<template>
    <div>
        
        <div class="text-left">
            <h3 class="mb-3">{{$t('cal_profit_Loss')}}</h3>
            <p>{{$t('cal_profitL_Txt')}}</p>
        </div>
        <div class="verticallyTab mt-5">
			<p v-if="message != ''" style="color:red">{{message}}</p>
            <div class="bottomTab w-100">
                <div class="stepForm-contact mt-5">
                    <div class="row">
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field  form-control" @change="currencyList()" v-model="segm" v-validate="'required'" name="segm" :class="{ 'is-invalid': submitted && errors.has('segm'), 'active' : segm != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                   <!--  <option value=""></option> -->
                                    <option value="Forex">{{$t('cal_marg_forex')}}</option>
                                    <option value="Commodities">{{$t('cal_marg_commodities')}}</option>
                                    <option value="INDICIES">{{$t('cal_marg_indices')}}</option>
                                    <!--<option>Crypto</option>-->
                                </select>
                                <label class="float-label">{{$t('fxAssetClass')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('segm')">{{$t('cal_profitLField_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field  form-control" v-model="basecurreny" v-validate="'required'" name="basecurreny" :class="{ 'is-invalid': submitted && errors.has('basecurreny'), 'active' : basecurreny != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                   <!--  <option value=""></option> -->
                                    <option value="USD">{{$t('cal_comm_USD')}}</option>
                                    <option value="GBP">{{$t('cal_comm_GBP')}}</option>
                                    <option value="AUD">{{$t('cal_comm_AUD')}}</option>
                                    <option value="EUR">{{$t('cal_comm_EUR')}}</option>
                                </select>
                                <label class="float-label">{{$t('cal_profitL_accBaseCurr')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('basecurreny')">{{$t('cal_profitLField_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <select class="selectpicker float-field  form-control" v-model="selectedSymbol" v-validate="'required'" name="selectedSymbol" :class="{ 'is-invalid': submitted && errors.has('selectedSymbol'), 'active' : selectedSymbol != '' }" onclick="this.setAttribute('value', this.value);" value="">
                                   <!--  <option value=""></option> -->
                                   <option v-for="spreads in isins" :value="spreads">{{spreads}}</option>
                                </select>
                                <label class="float-label">{{$t('cal_profitL_Symbol')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('selectedSymbol')">{{$t('cal_profitLField_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-12">
                            <div class="form-group field-wrapper text-left">
                                <label class="float-label-custom">{{$t('cal_profitL_Pos_Type')}}</label>
                                <div class="d-flex align-items-center mb-3">
                                    <label class="customRadio-button m-0 mr-2">{{$t('cal_profitL_Buy')}}
                                        <input type="radio" class="form-control" value="B" v-model="orderType" v-validate="'required'" name="orderType" :class="{ 'is-invalid': submitted && errors.has('orderType') }">
                                        <span class="checkmark"></span>
                                    </label>
                                    <label class="customRadio-button m-0">{{$t('cal_profitL_Sell')}}
                                        <input type="radio" class="form-control" value="S" v-model="orderType" v-validate="'required'" name="orderType" :class="{ 'is-invalid': submitted && errors.has('orderType') }">
                                        <span class="checkmark"></span>
                                    </label>
									<p class="error" v-if="submitted" v-for="error in errors.collect('orderType')">{{$t('cal_profitLField_req')}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text" class="float-field form-control" v-model="openPrice" v-validate="{ required: true,decimal:10}" name="openPrice" :class="{ 'is-invalid': submitted && errors.has('openPrice') }">
                                <label class="float-label">{{$t('cal_profitL_Open_Price')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('openPrice')">{{$t('cal_profitLField_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <input placeholder=" " type="text"  class="float-field form-control" v-model="closePrice" v-validate="{ required: true,decimal:10}" name="closePrice" :class="{ 'is-invalid': submitted && errors.has('closePrice') }">
                                <label class="float-label">{{$t('cal_profitL_Close_Price')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('closePrice')">{{$t('cal_profitLField_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group field-wrapper">
                                <input type="text" v-model="tradesize" class="float-field form-control" v-validate="{ required: true,decimal:5}" name="tradesize" :class="{ 'is-invalid': submitted && errors.has('tradesize') }">
                                <label class="float-label" style="text-transform: none !important;">{{$t('cal_profitL_trade_size_lot')}}</label>
								<p class="error" v-if="submitted" v-for="error in errors.collect('tradesize')">{{$t('cal_profitLField_req')}}</p>
                            </div>
                        </div>
                        <div class="col-12 col-md-12">
                            <div class="form-group field-wrapper">
                                <a href="#" class="common_btn" v-on:click.prevent="calculatePnL()">{{$t('cal_profitL_Now')}}</a>
                                <p class="mt-3">{{$t('cal_profit_Loss')}}: {{basecurreny}} {{pnl}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'Profit_loss',
        mixins: [fxViewMixins],
        data() {
            return {
                "isins":'',
                "segm": 'Forex',
                "tradesize": 0,
                "selectedSymbol":"",
                "selectedSeg":"",
                "commission": 0,
                "basecurreny":'USD',
                "orderType": 'B',
				"trend":'U',
                "pnl":0,
                "openPrice":"",
                "closePrice":"",
				submitted : false,
				message : '',
                allIsins:''
            }
        },
        methods:{
            currencyList(){
                this.isinList=""
                this.allIsins = this.$store.getters['/GET_ISINS_LIST'];
                this.isins = Object.keys(this.allIsins).filter(key => this.allIsins[key].type === this.segm);
                return this.isins;
            },
            calculatePnL(){
				const _that = this
                this.submitted = true;
				this.message = ''
                this.$validator.validate().then(valid => {
                    if (valid) {
						let BSprice=""
                        let calPNL=""
                        let selectedCurrecy= this.allIsins[_that.selectedSymbol]
                        let fetchedSelectedSymbol= ''
                        let priceFeed= this.$store.getters['/GET_PRICEFEED_DATA'];
                        let currencyPrice=''
                        const match = _that.selectedSymbol.match(/\((.*?)\)/); // Regex to find text within brackets
                        if (match) {
                            fetchedSelectedSymbol = match[0]; // Get the content inside the brackets
                        }else {
                            fetchedSelectedSymbol = _that.selectedSymbol; // No brackets found
                        }                       
                        let firstCurrency= ''

                        if((_that.openPrice && _that.openPrice !='') && (_that.closePrice && _that.closePrice !='')){
                            switch (_that.orderType) {
                                case ("S"):
                                    BSprice = _that.openPrice - _that.closePrice
                                break;
                                case ("B"):
                                    BSprice = _that.closePrice - _that.openPrice
                                break;
                                default:
                                break;
                            }
                        
                            calPNL = BSprice*selectedCurrecy.Contract_Size
                        
                            if(_that.segm=='Shares'){
                                firstCurrency="USD"
                            }else{
                                if(_that.selectedSymbol.includes('.') || _that.selectedSymbol.includes('(')){
                                    if(_that.selectedSymbol.includes('.')){
                                    let lastSymbol=_that.selectedSymbol.trim('.')
                                    firstCurrency = lastSymbol.slice('3','6')
                                    }else if(_that.selectedSymbol.includes('(')){
                                    let lastSymbol=_that.selectedSymbol.split('(')[0]
                                    firstCurrency = lastSymbol.slice('3','6')
                                    }
                                }else if(_that.selectedSymbol.includes('-')){
                                    let lastSymbol=_that.selectedSymbol.replace('-', '')
                                    firstCurrency = lastSymbol.slice('3','6')
                                }else{                            
                                    firstCurrency = _that.selectedSymbol.slice('3','6')
                                }
                            }
                            if(firstCurrency == _that.basecurreny){
                            
                                let secondaryCurrencyPrice = 1
                                currencyPrice= secondaryCurrencyPrice
                            }else{
                            
                                let secondaryCurrencyPrice = priceFeed[firstCurrency+_that.basecurreny]
                                if(secondaryCurrencyPrice){
                                
                                    currencyPrice = secondaryCurrencyPrice.A
                                
                                }else if(priceFeed[_that.basecurreny+firstCurrency]){
                                
                                    secondaryCurrencyPrice = priceFeed[_that.basecurreny+firstCurrency]
                                    currencyPrice = 1/secondaryCurrencyPrice.A
                                
                                }else{    
                                
                                    
                                    let allIsinList = []
                                    let filteredIsins=[]
                                    let secondPrice=''
                                    allIsinList= Object.keys(this.allIsins)
                                    filteredIsins = allIsinList.filter(val=>val.includes(firstCurrency)&&val.includes("USD"))
                                    let filteredIsinsSecond=[]
                                    filteredIsinsSecond = allIsinList.filter(val=>val.includes(_that.basecurreny))
                                    let filteredIsinsSecondPrice= priceFeed[filteredIsinsSecond[0]]
                                    secondPrice= 1/filteredIsinsSecondPrice.A
                                    filteredIsins.forEach(val=>{
                                        if(val.slice(0,3)=='USD'){
                                            let price= priceFeed['USD'+firstCurrency]
                                            currencyPrice = price.A*secondPrice
                                        }else if(val.slice(3,6)){
                                            let price= priceFeed[firstCurrency+'USD']
                                            currencyPrice = price.A*secondPrice
                                        }
                                    })
                                }
                            }
                            calPNL = (calPNL*currencyPrice).toFixed(2)
                            this.pnl = calPNL
                        }else{
                            return;
                        }
					}
				})
            }
        },
        created(){
            this.currencyList()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/fxView/shared/calculators/profit_Loss.vue